<srm-header [username]="displayName" [currentLocale]="currentLocale" [baseAppUrl]="baseAppUrl"
    [useSrmTranslations]="true" [disableLanguageSelection]="false" [appName]="'Supplier Profile'"
    [languages]="languages" [enableSupportTickets]="isSupplierTicketingEnabled" [toDoTaskCount]="toDoTaskCount"
    (selectLanguage)="onLanguageSelect($event)" (onViewMyTickets)="onViewMyTickets()"
    (actionEmitter)="navigateToTasks()" (logout)="logout()">
</srm-header>